import { create } from 'zustand';
import _ from 'lodash';

interface initDataState {
  param: any;
  bindParam: any;
  result: any;
  initPayload: any;
  payload: any;
  bind: (result: { data: any }) => void;
  bindPayload: (payload: { data: any }) => void;
}

// 그밖의 소득공제
export const initOthincomePayload = {
  acct_year: '', //연말정산   년도
  co_cd: '', //회사코드
  co_id: '', //사번
  in_data_seqid: 0, //입력데이터 sequence
  data_type: '',
  htx_amt: 0, //금액(국세청)
  amt: 0, //금액(일반)
  start_date: '', //계약일
  invest_year: '', //투자년도
  bank_cd: '', //은행코드
  account_num: '', //계좌번호
  sbp_date: '', //청약일
  is_htx_pdf: 'N', //국세청사용여부
  is_revision_rule: 'N', //개정규칙적용여부
  is_co_rep: 'N', //법인대표자 여부
};

/**
  그밖의 소득공제
**/
export const OthincomeDataStore = create<initDataState>(set => ({
  param: { initialSeq: 0 },
  bindParam: (bind: any) =>
    set(state => ({
      ...state,
      param: { ...state.param, ...bind },
    })),
  result: [],
  bind: (data: any) =>
    set(state => ({
      ...state,
      result: { ...state.result, ...data },
    })),
  initPayload: initOthincomePayload,
  payload: _.cloneDeep(initOthincomePayload),
  bindPayload: (data: any) =>
    set(state => ({
      ...state,
      payload: { ...state.payload, ...data },
    })),
}));
